import { createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: '#303f9f'
    },
    secondary: orange
  }
});

export default theme;
